import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { Link } from 'react-router';
import { FormattedMessage, FormattedDate, FormattedTime, injectIntl } from 'react-intl';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CartUserPrintList from './CartUserPrintList.react';
import CartPrintShopList from './CartPrintShopList.react';
import * as CartActions from '../actions/cart';
import * as DocumentStorageActions from '../actions/documentStorage';
import Modal from 'react-modal';
import Joyride from 'react-joyride';
import './../../../dist/theme/src/react-joyride-compiled.css'
import ConfirmModal from './ConfirmModal.react';


class Cart extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.handleSelect = this.handleSelect.bind(this);
        this.getPrintShopItems = this.getPrintShopItems.bind(this);
        this.getUserPrintItems = this.getUserPrintItems.bind(this);
        this.deleteCartItem = this.deleteCartItem.bind(this);
        this.closeCartProcessSuccessLayer = this.closeCartProcessSuccessLayer.bind(this);

        this.state = {
            joyrideOverlay: true,
            joyrideType: 'continuous',
            isRunning: false,
            autoStart: false,
            stepIndex: 0,
            steps: [],
            selector: '',
            firstVisitCart: true,
            tabIndex: 0,
            countMountedSubComponents: 0
        }
    }

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    handleSelect(index, last) {

        const newState = {
            ...this.state,
            tabIndex: index,
        };

        this.setState(newState);
    }

    componentWillMount() {

        const firstVisitCart = this.checkFirstVisitCart();

        this.setState ({
            firstVisitCart: firstVisitCart,
        });
    }

    componentDidMount() {
        // call dispatch
        let {dispatch, cart} = this.props;
        dispatch(CartActions.getCart());
        dispatch(DocumentStorageActions.getDocumentStorages());

        // check if user has already visited the page, if true => feature tour will be activated
        /*if(this.state.firstVisitCart) {
            setTimeout(() => {
                this.startTour();
            }, 100);
        }*/

        const steps = [
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_CART_TITLE_1' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_CART_MESSAGE_1' />,
                selector: '.user-print-list-table',
                position: 'bottom',
            },
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_CART_TITLE_2' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_CART_MESSAGE_2' />,
                selector: '.cart-to-print-shop-form',
                position: 'top',
            }
        ];


        this.addSteps(steps);
    }

    /** Checks if user visits the page for the first time*/
    checkFirstVisitCart() {
        if (localStorage.getItem("firstVisitCart") === null) {
            localStorage.setItem("firstVisitCart", false);
            return true;
        } else {
            return false;
        }
    }

    /** Feature Tour Steps*/
    addSteps(steps) {

        let newSteps = steps;

        if (!Array.isArray(newSteps)) {
            newSteps = [newSteps];
        }

        if (!newSteps.length) {
            return;
        }

        // Force setState to be synchronous to keep step order.
        this.setState(currentState => {
            currentState.steps = currentState.steps.concat(newSteps);
            return currentState;
        });
    }

    /** Starts Feature Tour*/
    startTour() {
        if (this.state.tabIndex !== 0) {
            setTimeout(() => {
                this.setState({
                    tabIndex: 0
                });
            }, 100);
        }
        if (!this.state.isRunning) {
            // first time
            this.setState({
                isRunning: true,
                autoStart: true
            });
        } else {
            this.refs.joyride.reset(true);
        }
    }

    /** Feature Tour Events*/
    callback(data) {

        // resets tour data after closing
        if(data.action === 'close') {
            this.refs.joyride.reset();
        }

        // handles tab transition
        if(data.type === 'step:after' && data.index === 0) {
            this.setState ({
                isRunning: false,
                tabIndex: 1,
            });
            setTimeout(() => {
                this.setState ({
                    isRunning: true
                });
            }, 100);
        }
    }

    /** Callback function for the sub components to check for readiness */
    checkSubcomponentMounted () {
        const printShopItems = this.getPrintShopItems();
        const userPrintItems = this.getUserPrintItems();
        const isEmptyCart = (printShopItems.length + userPrintItems.length === 0);

        this.setState({
            countMountedSubComponents: ++this.state.countMountedSubComponents
        });

        /*if (this.state.countMountedSubComponents >= 1) {
            if(!isEmptyCart) {
                if (this.state.firstVisitCart) {
                    this.startTour();
                }
            }
        }*/
    }

    deleteCartItem(documentStorageId) {
        const {dispatch} = this.props;
        const data = {
            title: this.props.intl.formatMessage({id: 'LABEL_CART_DELETE'}).toString(),
            msg: this.props.intl.formatMessage({id: 'CONFIRM_DELETE_CART_ITEM'}).toString(),
            cancelMsg: this.props.intl.formatMessage({id: 'LABEL_CANCEL'}).toString(),
            callback: () => dispatch(CartActions.updateItem(documentStorageId, 0))
        };

        ReactDOM.render(<ConfirmModal openModal={true} data={data}/>, document.getElementById('confirm-modal-overlay'));
    }

    getPrintShopItems() {

        const { cart, documentStorage } = this.props;

        let items = [];
        if (cart.loaded === true && documentStorage.loaded === true) {
            cart.data.printshopPrintable.map(item => {
                const storageItem = this.getDocumentStorage(item.documentStorage.id, documentStorage.data);
                if (storageItem !== false) {
                    items.push({
                        'id': item.id,
                        'quantity': item.quantity,
                        'documentStorageId': item.documentStorage.id,
                        'documentId': storageItem.documentId,
                        'author': storageItem.author,
                        'campaign': storageItem.campaign,
                        'additionalInfos': storageItem.additionalInfos,
                        'documentName': storageItem.documentName,
                        'storageName': storageItem.title,
                        'locale': storageItem.locale,
                        'storageUpdatedAt': storageItem.updatedAt,
                        'paperQuality': item.paperQuality,
                        'paperQualities': storageItem.paperQualities
                    });
                }
            });
        }

        return items;
    }

    getUserPrintItems() {
        const { cart, documentStorage } = this.props;
        let items = [];
        if (cart.loaded === true && documentStorage.loaded === true) {
            cart.data.userPrintable.map(item => {
                const storageItem = this.getDocumentStorage(item.documentStorage.id, documentStorage.data);
                if (storageItem !== false) {
                    items.push({
                        'id': item.id,
                        'quantity': item.quantity,
                        'documentStorageId': item.documentStorage.id,
                        'documentId': storageItem.documentId,
                        'author': storageItem.author,
                        'campaign': storageItem.campaign,
                        'additionalInfos': storageItem.additionalInfos,
                        'documentName': storageItem.documentName,
                        'storageName': storageItem.title,
                        'locale': storageItem.locale,
                        'storageUpdatedAt': storageItem.updatedAt
                    });
                }
            });
        }

        return items;
    }

    getDocumentStorage(id, documentStorageItems) {
        let retval = false;
        documentStorageItems.map(item => {
            if (item.id.toString() === id.toString()) {
                retval = item;
            }
        });

        return retval;
    }

    closeCartProcessSuccessLayer() {
        const { dispatch } = this.props;
        dispatch(CartActions.closeProcessCart());
    }

    render() {

        let renderContent = <div className="panel-body"><p><FormattedMessage id="TEXT_CART_EMPTY"/></p></div>;

        // feature tour constants
        const {
            isRunning,
            autoStart,
            joyrideOverlay,
            joyrideType,
            stepIndex,
            steps
        } = this.state;

        const { cart, documentStorage } = this.props;
        if (cart.loaded === true && documentStorage.loaded === true) {
            const printShopItems = this.getPrintShopItems();
            const userPrintItems = this.getUserPrintItems();
            const isEmptyCart = (printShopItems.length + userPrintItems.length === 0);

            if (!isEmptyCart) {
                renderContent = <div>
                   {/* <div onClick={this.startTour.bind(this)} className="joyride-start-area joyride-navbar-button">
                        <i className="material-icons joyride-start-icon">help</i>
                        <FormattedMessage id="LABEL_FEATURE_TOUR"/>
                    </div>*/}
                    <div className="panel-body">
                        <Tabs onSelect={this.handleSelect} selectedIndex={this.state.tabIndex}>
                            <TabList>
                                <Tab><FormattedMessage id="LABEL_CART_TAB_PRINTING_USER"/>
                                    ({userPrintItems.length})</Tab>
                                <Tab><FormattedMessage id="LABEL_CART_TAB_PRINTING_SHOP"/>
                                    ({printShopItems.length})</Tab>
                            </TabList>
                            <TabPanel>
                                <CartUserPrintList items={ this.getUserPrintItems() }
                                                   deleteCartItem={ this.deleteCartItem }
                                                   checkSubcomponentMounted={this.checkSubcomponentMounted.bind(this)}/>
                            </TabPanel>
                            <TabPanel>
                                <CartPrintShopList items={ this.getPrintShopItems() }
                                                   deleteCartItem={ this.deleteCartItem }/>
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            }
        }

        return (

            <div>
                <Joyride
                    ref="joyride"
                    callback={this.callback.bind(this)}
                    disableOverlay={false}
                    locale={{
                        back: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_BACK"/></span>),
                        close: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_CLOSE"/></span>),
                        last: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_LAST"/></span>),
                        next: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_NEXT"/></span>),
                        skip: (<span><FormattedMessage id="LABEL_FEATURE_TOUR_SKIP"/></span>),
                    }}
                    run={isRunning}
                    autoStart={autoStart}
                    showOverlay={joyrideOverlay}
                    showSkipButton={true}
                    showStepsProgress={true}
                    stepIndex={stepIndex}
                    steps={steps}
                    type={joyrideType}
                />
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title"><FormattedMessage id="LABEL_CART"/></h3>
                    </div>
                    <div>
                        { renderContent }
                    </div>
                </div>
                <div id="confirm-modal-overlay"></div>
                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={cart.cartProcessSuccess}
                    onRequestClose={this.closeCartProcessSuccessLayer}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.closeCartProcessSuccessLayer}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                            </button>
                            <h4 className="modal-title"><FormattedMessage id="LABEL_PROCESS_CART_SUCCESS"/></h4>
                        </div>

                        <div className="modal-body">
                            <p><FormattedMessage id="TEXT_PROCESS_CART_SUCCESS"/></p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default"
                                    onClick={this.closeCartProcessSuccessLayer}>
                                <FormattedMessage id="LABEL_CLOSE"/></button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default connect(state => ({ cart: state.cart, documentStorage: state.documentStorage }))(injectIntl(Cart));


// WEBPACK FOOTER //
// ./src/js/components/Cart.react.jsx